import { LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  { headerName: 'Name', field: 'name', width: LIST_WIDTH.OBJECT_NAME },
  {
    headerName: 'Manager Name',
    field: 'managerName',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: 'Manager Email',
    field: 'managerEmail',
    width: LIST_WIDTH.xl,
  },
  {
    headerName: 'Country',
    field: 'country',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Date Received',
    field: 'dateReceived',
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    headerName: 'Date Updated',
    field: 'dateUpdated',
    width: LIST_WIDTH.TIME_DATE,
  },
  { headerName: 'Status', field: 'status', width: LIST_WIDTH.STATUS },
];
